<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted } from "vue";

import BaseVGrid from "@/components/BaseVGrid.vue";
import { getSiteData, refreshFullPageContent, goBack } from "@/NavigationHelper";

interface Props {
  query?: string;
  showClose?: boolean;
  onReloadData?: boolean;
  aic?: number;
}
const props = defineProps<Props>();
const siteData = getSiteData();

let query = ref<string>("");
let queryAIC = ref<number>(0);
let showClose = ref<boolean>(false);
let initalized = ref<boolean>(false);

onMounted(() => {
  showClose.value = siteData?.showClose ?? props.showClose;
  query.value = siteData?.query ?? props.query;
  queryAIC.value = siteData?.aic ?? props.aic ?? 0;
  if (!query || Object.keys(query).length === 0) {
    console.log("Query is empty");
    return;
  }
  initalized.value = true;
});
function onReloadData() {
  // siteData.onReloadData = true;
}
</script>
<template>
  <BaseVGrid
    v-if="initalized"
    :query="query"
    :queryAic="queryAIC"
    :showClose="showClose"
    :preSelectedRow="queryAIC"
    @onReloadData="onReloadData"
    @back="goBack()"
  />
</template>

<style scoped></style>
